import {schema} from 'normalizr'
import {channelSchema} from './channel'
import {userSchema} from './user'
import {widgetSchema} from './widget'

export const askSchema = new schema.Entity(
  'asks',
  {
    creator: new schema.Union(
      {
        user: userSchema
      },
      '_type'
    ),
    container: new schema.Union(
      {
        channel: channelSchema
      },
      '_type'
    ),
    widgets: [widgetSchema]
  },
  {
    idAttribute: 'idname'
  }
)
